import { createFileRoute, redirect } from '@tanstack/react-router'

// Bare Gamma has no pane of its own — land on the first sub-tab.
export const Route = createFileRoute('/_app/dev-resources/transitions/one/item/gamma/')({
  beforeLoad: () => {
    throw redirect({ to: '/dev-resources/transitions/one/item/gamma/x' })
  },
})
